import { useEffect } from 'react';

export default function AppModal({
    widgetOpen,
    children,
}: {
    widgetOpen: boolean;
    setWidgetOpen: (open: boolean) => void;
    children: React.ReactNode;
}) {
    useEffect(() => {
        // fireknife-scroll-lock should be added to the body when the widget is open
        // and removed when the widget is closed
        if (widgetOpen) {
            document.body.classList.add('fireknife-scroll-lock');
        } else {
            document.body.classList.remove('fireknife-scroll-lock');
        }
        return () => {
            // cleanup function to remove the class when the component is unmounted
            document.body.classList.remove('fireknife-scroll-lock');
        };
    }, [widgetOpen]);

    return (
        <div className="fireknife-widget-overlay">
            <div className="fireknife-widget-backdrop" />
            <div className="fireknife-widget-scrollback">
                <div className="fireknife-widget-container">{children}</div>
            </div>
        </div>
    );
}
